// WellnessCarousel.jsx
"use client"

import { useState, useEffect, useRef } from "react"
import img1 from "../assets/images/food1.png"
import img2 from "../assets/images/food2.png"
import img3 from "../assets/images/food3.png"
import img5 from "../assets/images/food5.png"
import img7 from "../assets/images/food7.png"
import img8 from "../assets/images/food8.png"
import "../styles/Caro.css"

const WellnessCarousel = () => {
  const [activeIndex, setActiveIndex] = useState(2)
  const [isHovering, setIsHovering] = useState(false)
  const carouselRef = useRef(null)

  const slides = [
    { id: 1, image: img1, alt: "Person preparing ingredients" },
    { id: 2, image: img2, alt: "Person pouring olive oil" },
    { id: 3, image: img3, alt: "Person pouring olive oil" },
    { id: 4, image: img5, alt: "Person with healthy food" },
    { id: 5, image: img7, alt: "Person with healthy food" },
    { id: 6, image: img8, alt: "Person with healthy food" },
  ]

  const handleMouseEnter = (index) => {
    setIsHovering(true)
    setActiveIndex(index)
  }

  const handleMouseLeave = () => {
    setIsHovering(false)
    setActiveIndex(2) // Reset to center slide
  }

  const handleTouchStart = (index) => {
    setActiveIndex(index)
  }

  // DESKTOP: Auto-rotate when not hovering
  useEffect(() => {
    if (!isHovering) {
      const interval = setInterval(() => {
        setActiveIndex((prevIndex) => {
          return prevIndex >= slides.length - 1 ? 0 : prevIndex + 1
        })
      }, 2000)
      return () => clearInterval(interval)
    }
  }, [isHovering, slides.length])

  // MOBILE: infinite auto-scroll every 2000ms
  useEffect(() => {
    if (typeof window === "undefined") return
    const mq = window.matchMedia("(max-width: 767px)")
    if (!mq.matches || !carouselRef.current) return

    const carousel = carouselRef.current
    const computeStep = () => {
      const slide = carousel.querySelector(".slide")
      const style = getComputedStyle(slide)
      return slide.offsetWidth + parseInt(style.marginRight)
    }
    let scrollStep = computeStep()

    const interval = setInterval(() => {
      if (carousel.scrollLeft + carousel.offsetWidth >= carousel.scrollWidth) {
        carousel.scrollTo({ left: 0, behavior: "smooth" })
      } else {
        carousel.scrollBy({ left: scrollStep, behavior: "smooth" })
      }
    }, 2000)

    return () => clearInterval(interval)
  }, [])

  return (
    <div className="wellness-carousel-container">
      <div className="title-bar">
        <h2>'Haronics' The Future of Healthy Oils</h2>
        <h5>Experience the pure, nutty warmth ideal for everyday cooking, packed with heart-healthy goodness. </h5>
      </div>

      <div className="carousel" ref={carouselRef}>
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`slide ${activeIndex === index ? "active" : ""}`}
            onMouseEnter={() => handleMouseEnter(index)}
            onMouseLeave={handleMouseLeave}
            onTouchStart={() => handleTouchStart(index)}
          >
            <div className="slide-inner">
              <img src={slide.image || "/placeholder.svg"} alt={slide.alt} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default WellnessCarousel
